var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.$setClasses},[_c('nxt-tooltip',{attrs:{"content":_vm.content,"not-disabled-tooltip":!!_vm.content,"placement":"top-start","popper-class":"rating-icon"}},[_c('img',{class:_vm.$vClass('image'),attrs:{"alt":_vm.alt,"src":_vm.src,"height":"48","width":"48"}})])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }